export default __webpack_public_path__ + "static/media/caseSlide2.e3238343.png";